module.exports = __webpack_public_path__ + "img/coming-soon.704e8f46.svg";